/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/explicit-function-return-type */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createThrottledQueue<T extends any[]>(
  fn: (...args: T) => Promise<void>,
  delay: number
) {
  const queue: T[] = [];
  let isProcessing = false;
  let lastCallTime = 0;

  async function processQueue() {
    if (isProcessing || queue.length === 0) return;

    isProcessing = true;

    while (queue.length > 0) {
      const timeSinceLastCall = Date.now() - lastCallTime;

      if (timeSinceLastCall < delay) {
        await new Promise((resolve) =>
          // eslint-disable-next-line no-promise-executor-return
          setTimeout(resolve, delay - timeSinceLastCall)
        );
      }

      const args = queue.shift();
      if (args) {
        await fn(...args);
        lastCallTime = Date.now();
      }
    }

    isProcessing = false;
  }

  return (...args: T) => {
    queue.push(args);
    processQueue();
  };
}
